import { Box, Card, CardContent } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Dialog, DialogActions } from '../../../../../components/molecules/dialog';

import { DataStatusIndicator } from '@/components/molecules/data-status-indicator/data-status-indicator';
import { useAccessControlProfiles } from '@/features/access-control-profiles/hooks/query/use-access-control-profiles';
import { useUpdateDestinationAccessControlProfiles } from '@/features/destinations/hooks/mutation/use-update-destination-access-control-profiles';

interface Props extends DialogActions {
  destinationId: number;
  accessControlProfilesIds: number[];
}

const AssignAccessControlProfilesToDestinationDialog = ({
  open,
  onCancel,
  destinationId,
  accessControlProfilesIds,
}: Props) => {
  const { t } = useTranslation(['destinations']);

  const onClose = () => {
    onCancel?.();
    setPickedAccessControlProfilesIds([]);
  };

  const { data, isLoading, error } = useAccessControlProfiles();

  const [pickedAccessControlProfilesIds, setPickedAccessControlProfilesIds] = useState(
    accessControlProfilesIds || [],
  );

  const handleSelectAccessControlProfile = (id: number) => {
    const active = [...pickedAccessControlProfilesIds];

    if (active.indexOf(id) > -1) {
      active.splice(active.indexOf(id), 1);
    } else active.push(id);

    return setPickedAccessControlProfilesIds(active);
  };

  const { mutate } = useUpdateDestinationAccessControlProfiles(onClose);

  useEffect(() => {
    if (accessControlProfilesIds?.length > 0) {
      setPickedAccessControlProfilesIds(accessControlProfilesIds);
    }
  }, [accessControlProfilesIds]);

  return (
    <Dialog
      open={open}
      title={t('destinations:modalAssign.title')}
      onCancel={onClose}
      onConfirm={() =>
        mutate({ id: destinationId, accessControlProfilesIds: pickedAccessControlProfilesIds })
      }
      variant="info">
      <Box sx={{ my: 1 }}>
        {data?.map(({ id, name }) => {
          return (
            <Card
              onClick={() => handleSelectAccessControlProfile(id)}
              key={id}
              sx={{
                boxShadow: theme => {
                  return pickedAccessControlProfilesIds?.includes(id)
                    ? `0px 0px 0px 2px ${theme.palette.primary.main}`
                    : `0px 0px 0px 1px ${theme.palette.divider}`;
                },
                cursor: 'pointer',
                mb: 2,
              }}>
              <CardContent
                sx={{
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  display: 'flex',
                }}>
                {name}
              </CardContent>
            </Card>
          );
        })}
        <DataStatusIndicator
          dataLength={data?.length || 0}
          error={error?.response?.data?.message}
          isFetching={isLoading}
        />
      </Box>
    </Dialog>
  );
};

export default AssignAccessControlProfilesToDestinationDialog;
